export class GetCustomerRequestBody {
  dmsCustomerId: string;
  maxVehicleResults?: number;
}
